<script context="module">
  import { get_date_or_null, get_field_if_exists } from "./UtilsNewDesign.svelte";
  import { get_difference_in_days } from "./Utils.svelte";

  let source_cate_index_dict = {
    Advertising: 0,
    Events: 1,
    Organic: 2,
    Sales: 3,
  };

  function month(date) {
    var month_number = date.getMonth() + 1;
    var month_str = "";
    if (month_number < 10) {
      month_str = "0" + month_number.toString();
    } else {
      month_str = "0" + month_number.toString();
    }
    return month_str;
  }

  function max_date(date_1, date_2) {
    if (date_1 > date_2) {
      return date_1;
    } else {
      return date_2;
    }
  }

  function max_number(n_1, n_2) {
    if (n_1 > n_2) {
      return n_1;
    } else {
      return n_2;
    }
  }

  export function min_date(date_1, date_2) {
    if (date_1 < date_2) {
      return date_1;
    } else {
      return date_2;
    }
  }

  function overlapping_days(target_start, target_end, filter_start, filter_end, debug = false) {
    if (filter_start > target_end) {
      return 0;
    }
    if (filter_end < target_start) {
      return 0;
    }
    if (target_end.getHours() != 23) {
      target_end.setHours(23);
    }
    var days = max_number(get_difference_in_days(min_date(target_end, filter_end), max_date(target_start, filter_start), debug), 0);
    return days;
  }

  export function get_anteilsmaessig_date_filter_range(target_goal, months, filter_start, filter_end, debug = false) {
    var target_start = new Date(target_goal["start_date"]);
    var target_end = new Date(target_goal["end_date"]);

    // console.log("filter_end in get_anteilsmaessig: ", filter_end)

    var days = overlapping_days(target_start, target_end, filter_start, filter_end, debug);

    if (target_end.getHours() != 23) {
      target_end.setHours(23);
    }

    var target_days_number = get_difference_in_days(target_start, target_end, debug);

    if (target_goal["name"] == "SOLD_BOL_TARGET MKT_AUS_23" || target_goal["name"] == "SOLD_BOL_TARGET MKT_AU_23") {
      overlapping_days(target_start, target_end, filter_start, filter_end, true);
    }

    return (target_goal["target_goal"] * days) / target_days_number;
  }

  export function get_anteilsmaessig(target_goal, year, months, manual_month_count = 0) {
    var count_months = 0;

    var current_month_dabei = false;

    if (manual_month_count == 0) {
      months.forEach((m) => {
        if (m.substring(0, 4) == year.toString()) {
          count_months += 1;
        }
        if (m.substring(0, 4) == new Date().getFullYear().toString() && m.substring(5, 7) == month(new Date())) {
          current_month_dabei = true;
        }
      });
    } else {
      count_months = manual_month_count;
    }

    const daysInMonth = (year, month) => new Date(year, month, 0).getDate();

    // var ret = (target_goal / 12) * count_months
    var ret = (target_goal / 12) * (count_months - 1);

    if (current_month_dabei) {
      ret += (target_goal / 12) * (new Date().getDate() / daysInMonth(new Date().getFullYear(), new Date().getMonth() + 1));
    } else {
      ret += target_goal / 12;
    }

    return ret;
  }

  export function filter_messenger_res_group_by_partner_only_herdsize(messenger_res) {
    let ret = {};

    messenger_res.forEach((element) => {
      var m = element[1];

      if (!m["partner_id"]) {
        return;
      }

      if (!m["herd_size"]) {
        return;
      }

      if (!m["qty"]) {
        return;
      }

      if (m["partner_id"][0] in ret) {
        ret[m["partner_id"][0]].push({ date: m["date"], qty: m["qty"] });
      } else {
        ret[m["partner_id"][0]] = [{ date: m["date"], qty: m["qty"] }];
      }
    });

    return ret;
  }

  export function calc_order_intake(sale_order_all, res_partner_dict, months, neu_oder_altkunde = "neu") {
    let ret = {};
    let chosen_months_astrid = 6;

    let count_boli = {};

    let ret_per_salesperson = {};

    months.forEach((m) => {
      ret[m] = 0;
    });

    months.forEach((m) => {
      count_boli[m] = 0;
    });

    console.log("sale_order_all", sale_order_all);

    sale_order_all.forEach((s) => {
      var element = s[1];
      var year_month = "";

      if (element["x_studio_order_date_mw"]) {
        year_month = element["x_studio_order_date_mw"].substring(0, 7);
      }

      if (!element["partner"]) {
        return;
      }

      let date_of_order = new Date(element["x_studio_order_date_mw"]);

      let partner_obj = res_partner_dict[element["partner"][0]];

      if (!partner_obj) {
        return;
      }

      var cust_since = new Date();
      if (partner_obj["x_studio_kunde_seit"]) {
        var date = new Date(partner_obj["x_studio_kunde_seit"]);
        if (date < cust_since) {
          cust_since = date;
        }
      }
      if (partner_obj["first_order_date"]) {
        var date = new Date(partner_obj["first_order_date"]);
        if (date < cust_since) {
          cust_since = date;
        }
      }

      if (!(date_of_order && (element["state"] == "done" || element["state"] == "sale"))) {
        return;
      }

      // console.log("element: ", element)
      // console.log("element['x_studio_kunde_seit']: ", element['x_studio_kunde_seit'])
      // console.log("element['first_order_date']: ", element['first_order_date'])

      // console.log("cust_since: ", cust_since)
      let neukunden_datum = new Date(cust_since);
      neukunden_datum.setMonth(neukunden_datum.getMonth() + chosen_months_astrid);
      // console.log("neukunden_datum: ", neukunden_datum)

      if (!(element["product__amount"] > 0)) {
        return;
      }
      if (!(element["price_total"] > 0)) {
        return;
      }
      if (element["product_type"] != "Sales Product / Classic Bolus") {
        return;
      }
      if (element["partner"]) {
        if (element["partner"][1].toLowerCase().includes("smaxtec")) {
          return;
        }
      }
      if (element["partner"]) {
        if (element["partner"][1].toLowerCase().includes("Smaxtec")) {
          return;
        }
      }

      if (year_month in ret) {
        if (!(element["salesman__name"].toString() in ret_per_salesperson)) {
          ret_per_salesperson[element["salesman__name"]] = 0;
        }

        ret_per_salesperson[element["salesman__name"].toString()] += element["euro"];

        if (neu_oder_altkunde == "neu") {
          // console.log("date_of_order: ", date_of_order)
          // console.log("neukunden_datum: ", neukunden_datum)
          if (neukunden_datum > date_of_order) {
            ret[year_month] += element["euro"];
            count_boli[year_month] += element["product_uom_qty"];
          }
        }
        if (neu_oder_altkunde == "alt") {
          if (neukunden_datum <= date_of_order) {
            ret[year_month] += element["euro"];
            count_boli[year_month] += element["product_uom_qty"];
          }
        }
      }
    });

    console.log("count_boli: ", count_boli);

    return { all: ret, per_salesperson: ret_per_salesperson };
  }

  export function getTopAndBottomValues(dictionary) {
    const keyValuePairs = Object.entries(dictionary);

    keyValuePairs.sort((a, b) => a[1] - b[1]);

    const lowestValues = keyValuePairs.slice(0, 3);
    const highestValues = keyValuePairs.slice(-3).reverse();

    const rankedLowest = lowestValues.map((pair, index) => ({
      rank: index + 1,
      key: pair[0],
      value: pair[1],
    }));

    const rankedHighest = highestValues.map((pair, index) => ({
      rank: index + 1,
      key: pair[0],
      value: pair[1],
    }));

    return {
      topThreeHighest: rankedHighest,
      topThreeLowest: rankedLowest,
    };
  }

  // Example dictionary
  const data = {
    "Kai Lackner": 717273.77,
    "Clint Brereton": 595678.51,
    "Amanda Dolphin": 293563.86,
    "John Doe": 1000000,
  };

  // export function getTopAndBottomValues(dictionary) {
  //   // Convert the dictionary into an array of key-value pairs
  //   const keyValuePairs = Object.entries(dictionary);

  //   // Sort the array by values in ascending order
  //   keyValuePairs.sort((a, b) => a[1] - b[1]);

  //   // Get the top three lowest values
  //   const lowestValues = keyValuePairs.slice(0, 3);

  //   // Get the top three highest values by reversing the array
  //   const highestValues = keyValuePairs.slice(-3).reverse();

  //   return {
  //     topThreeHighest: highestValues,
  //     topThreeLowest: lowestValues,
  //   };
  // }

  export function calc_active_customers_per_month(months, countires, res_partner_all, messenger_res_only_with_herdsize, selected_months) {
    let ret_dict_sums = {};
    let ret_dict = {};
    let ret_dict_count = {};

    ret_dict["Total"] = {};

    countires.forEach((c) => {
      ret_dict_sums[c["long"]] = {};
      ret_dict[c["long"]] = {};
      ret_dict_count[c["long"]] = {};

      months.forEach((m) => {
        ret_dict_sums[c["long"]][m] = 0;
        ret_dict[c["long"]][m] = 0;
        ret_dict_count[c["long"]][m] = 0;
        ret_dict["Total"][m] = 0;
      });
    });

    res_partner_all.forEach((element) => {
      var first_order_date = element[1]["first_order_date"];

      var company_type = element[1]["company_type"];

      if (company_type != "company") {
        return;
      }

      if (!element[1]["country_id"]) {
        return;
      }
      var country = element[1]["country_id"][1];

      if (!is_country_checked(countires, country)) {
        return;
      }

      var date_to_use = first_order_date;

      if (element[1]["x_studio_kunde_seit"]) {
        var date_obj_element_kunde_seit = new Date(element[1]["x_studio_kunde_seit"]);
        if (element[1]["first_order_date"]) {
          var date_obj_first_order_date = new Date(element[1]["first_order_date"]);
          if (date_obj_element_kunde_seit < date_obj_first_order_date) {
            date_to_use = element[1]["x_studio_kunde_seit"];
          }
        } else {
          date_to_use = element[1]["x_studio_kunde_seit"];
        }
      }

      if (element[1]["id"] in messenger_res_only_with_herdsize) {
        var messenger_res_list_from_partner = messenger_res_only_with_herdsize[element[1]["id"]];

        messenger_res_list_from_partner.forEach((mrlfp) => {
          if (months.includes(mrlfp["date"].substring(0, 7))) {
            if (country in ret_dict_sums) {
              ret_dict_sums[country][mrlfp["date"].substring(0, 7)] += mrlfp["qty"];
              ret_dict_count[country][mrlfp["date"].substring(0, 7)] += 1;

              if (country == "New Zealand" && mrlfp["date"].substring(0, 7) == "2023-06") {
                // console.log("partner: ", element[1])
              }
            } else {
              ret_dict_sums["ROW"][mrlfp["date"].substring(0, 7)] += mrlfp["qty"];
              ret_dict_count["ROW"][mrlfp["date"].substring(0, 7)] += 1;
            }
          }
        });
      } else {
        if (element[1]["active_animals"]) {
        }
      }
    });

    var past_month_key = "";

    months.forEach((m) => {
      // if(!selected_months.includes(m)){
      //   return
      // }

      var total_count = 0;
      var total_sum = 0;

      countires.forEach((c) => {
        ret_dict[c["long"]][m] = ret_dict_sums[c["long"]][m] / ret_dict_count[c["long"]][m];

        if (parseInt(m.substring(0, 4)) == new Date().getFullYear() && parseInt(m.substring(5, 7)) == new Date().getMonth() + 1) {
          if (ret_dict_count[c["long"]][m] * 10 < ret_dict_count[c["long"]][past_month_key]) {
            ret_dict[c["long"]][m] = ret_dict_sums[c["long"]][past_month_key] / ret_dict_count[c["long"]][past_month_key];
            total_sum += ret_dict_sums[c["long"]][past_month_key];
            total_count += ret_dict_count[c["long"]][past_month_key];
          } else {
            total_sum += ret_dict_sums[c["long"]][m];
            total_count += ret_dict_count[c["long"]][m];
          }
        } else {
          total_sum += ret_dict_sums[c["long"]][m];
          total_count += ret_dict_count[c["long"]][m];
        }
      });

      ret_dict["ROW"][m] = ret_dict_sums["ROW"][m] / ret_dict_count["ROW"][m];
      if (parseInt(m.substring(0, 4)) == new Date().getFullYear() && parseInt(m.substring(5, 7)) == new Date().getMonth() + 1) {
        if (ret_dict_count["ROW"][m] * 10 < ret_dict_count["ROW"][past_month_key]) {
          ret_dict["ROW"][m] = ret_dict_sums["ROW"][past_month_key] / ret_dict_count["ROW"][past_month_key];
          total_sum += ret_dict_sums["ROW"][past_month_key];
          total_count += ret_dict_count["ROW"][past_month_key];
        } else {
          total_sum += ret_dict_sums["ROW"][m];
          total_count += ret_dict_count["ROW"][m];
        }
      } else {
        total_sum += ret_dict_sums["ROW"][m];
        total_count += ret_dict_count["ROW"][m];
      }

      ret_dict["Total"][m] = total_sum / total_count;

      past_month_key = m;
    });

    months.forEach((m) => {
      countires.forEach((c) => {
        if (!selected_months.includes(m)) {
          delete ret_dict[c["long"]][m];
        }
      });
      if (!selected_months.includes(m)) {
        delete ret_dict["ROW"][m];
      }
    });

    return { ret_dict: { ret_dict }, active_customers: ret_dict_count };
  }

  export function get_last_value_if_not_very_small(active_customers, laender_dict, months, months_all) {
    let m = months[months.length - 1];
    let ret_dict = {};

    let m_index = months_all.findIndex((month) => month === m);
    let m_index_davor = m_index - 1;

    laender_dict.forEach((c) => {
      var land = c["long"];

      if (
        active_customers[land][months_all[m_index]] == 0 ||
        active_customers[land][months_all[m_index]] * 10 < active_customers[land][months_all[m_index_davor]]
      ) {
        ret_dict[land] = active_customers[land][months_all[m_index_davor]];
      } else {
        ret_dict[land] = active_customers[land][months_all[m_index]];
      }
    });

    ret_dict["Total"] = dict_to_sum(ret_dict);

    return ret_dict;
  }

  export function get_years_list_from_dates(marketing_start_date, marketing_end_date) {
    var year_start = marketing_start_date.getFullYear();
    var year_end = marketing_end_date.getFullYear();

    var y = year_start;
    let ret_string = y.toString();

    y += 1;

    while (y <= year_end) {
      ret_string = ret_string + "," + y.toString();
      y += 1;
    }
    return ret_string;
  }

  export function sum_up_months_from_country(herd_churn_per_country_per_month, laender_dict, months) {
    let ret_dict = {};

    laender_dict.forEach((c) => {
      ret_dict[c["long"]] = 0;

      months.forEach((m) => {
        ret_dict[c["long"]] += herd_churn_per_country_per_month[c["long"]][m];
      });
    });

    ret_dict["Total"] = dict_to_sum(ret_dict);

    return ret_dict;
  }

  export function calc_activated_all_removed_not_new_cust_boli(activated_all) {
    let ret = {};
    var chosen_months_astrid = 6;

    Object.keys(activated_all).forEach((a_key) => {
      ret[a_key] = {};

      var start_date = min_of_cust_dates(activated_all[a_key]);
      var start_date_obj = new Date(start_date);

      var end_date_obj = new Date(start_date);
      end_date_obj.setMonth(end_date_obj.getMonth() + chosen_months_astrid);

      Object.keys(activated_all[a_key]).forEach((key) => {
        if (!key.includes("activated_") && !key.includes("deactivated_")) {
          ret[a_key][key] = activated_all[a_key][key];
        } else {
          if (key.includes("activated_") && start_date) {
            var month_index = key.split("activated_")[1];
            var month_index_date = new Date(month_index.toString() + "-15");
            if (start_date_obj <= month_index_date && end_date_obj >= month_index_date) {
              ret[a_key][key] = activated_all[a_key][key];
            }
          }
          // if(key.includes('deactivated_')){
          //   var month_index = key.split('deactivated_')[1]
          //   var month_index_date = new Date(month_index.toString()+'-15')
          //   if(start_date_obj <= month_index_date && end_date_obj >= month_index_date){
          //     ret[a_key][key] = activated_all[a_key][key];
          //   }
          // }
        }
      });
    });

    let ret_list = [];
    Object.keys(activated_all).forEach((a_key) => {
      ret_list.push(ret[a_key]);
    });

    return ret_list;
  }

  function min_of_cust_dates(element) {
    var first_order_date = element["first_order_date"];
    var x_studio_kunde_seit = element["x_studio_kunde_seit"];

    if (!first_order_date && !x_studio_kunde_seit) {
      return false;
    }

    if (first_order_date && !x_studio_kunde_seit) {
      return first_order_date;
    }
    if (!first_order_date && x_studio_kunde_seit) {
      return x_studio_kunde_seit;
    }

    var first_order_date_obj = new Date(element["first_order_date"]);
    var x_studio_kunde_seit_obj = new Date(element["x_studio_kunde_seit"]);

    if (first_order_date_obj < x_studio_kunde_seit_obj) {
      return first_order_date_obj;
    } else {
      return x_studio_kunde_seit_obj;
    }
  }

  export function subtract_country_month_dicts(dict_1, dict_2) {
    let ret = {};

    Object.keys(dict_1).forEach((country_key) => {
      Object.keys(dict_1[country_key]).forEach((m) => {
        if (!(country_key in ret)) {
          ret[country_key] = {};
        }
        if (!(m in ret[country_key])) {
          ret[country_key][m] = 0;
        }

        ret[country_key][m] = dict_1[country_key][m] - dict_2[country_key][m];
      });
    });

    return ret;
  }

  export function get_vorgaenger_active_animals(
    months,
    dict,
    index,
    basis,
    lost_dict = false,
    lost_deactivated_animals = false,
    new_boli_new_customers = false,
    lost_from_customer = false
  ) {
    if (index == 0) {
      return basis;
    }

    var a = basis;

    for (var i = 0; i < index; i = i + 1) {
      a += dict[months[i]];
      if (lost_dict) {
        a -= lost_dict[months[i]];
      }
      if (lost_deactivated_animals) {
        a -= lost_deactivated_animals[months[i]];
      }
      if (new_boli_new_customers) {
        a += new_boli_new_customers[months[i]];
      }
      if (lost_from_customer) {
        a -= lost_from_customer[months[i]];
      }
    }

    return a;
  }

  export function country_month_to_median(my_dict) {
    let ret_dict = {};

    for (const [country, value] of Object.entries(my_dict)) {
      ret_dict[country] = dict_to_median(value);
    }

    return ret_dict;
  }

  export function is_country_checked(laender_dict, country) {
    let ret = false;
    let found = false;

    laender_dict.forEach((c) => {
      if (c["long"] == country) {
        ret = c["checked"];
        found = true;
      }
    });

    if (found) {
      return ret;
    }

    laender_dict.forEach((c) => {
      if (c["long"] == "ROW") {
        ret = c["checked"];
        found = true;
      }
    });

    if (found) {
      return ret;
    }

    return false;
  }

  export function calc_active_animals(res_partner_all, messenger_res, marketing_start_date, marketing_end_date, months, laender_dict) {
    let act_market_share_per_country = calc_active_boli_per_country_per_month(
      messenger_res,
      months,
      laender_dict,
      marketing_start_date,
      marketing_end_date
    );

    let active_animals = 0;

    laender_dict.forEach((l) => {
      if (!l["checked"]) {
        return;
      }
      if (months.length > 1) {
        active_animals =
          active_animals +
          Math.max(
            act_market_share_per_country[l["long"]][months[months.length - 1]],
            act_market_share_per_country[l["long"]][months[months.length - 2]]
          );
      } else {
        active_animals = active_animals + act_market_share_per_country[l["long"]][months[0]];
      }
    });

    return active_animals;
  }

  export function calc_open_opps_per_country(months, countires, crm_lead_all, marketing_start_date, date_end) {
    let ret_dict = {};

    let date_to_compare = date_end;

    if (date_to_compare > new Date()) {
      date_to_compare = new Date();
    }

    countires.forEach((c) => {
      ret_dict[c["long"]] = 0;
    });

    crm_lead_all.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["create_date"]);
      var create_date_str = element["create_date"].substring(0, 7);
      var source = element["source_id"][1];
      var source_category = element["source_category"];
      var type = element["type"];
      var is_won = element["is_won"];
      var sold_boli = element["sum_of_boli_sold_overall"];
      var date_conversion = element["date_conversion"];
      var date_closed = element["date_closed"];
      var country = element["country_id"];
      var date_closed_obj;
      var date_conversion_obj;
      var stage = element["stage_id"];
      var date_last_stage_update = element["date_last_stage_update"];

      if (!date_conversion) {
        return;
      }

      var date_conversion_obj = new Date(element["date_conversion"]);

      if (date_conversion_obj > date_to_compare) {
        return;
      }

      if (!is_country_checked(countires, country[1])) {
        return;
      }

      if (type != "opportunity") {
        return;
      }

      if (date_closed) {
        date_closed_obj = new Date(date_closed);
      } else {
        date_closed_obj = false;
      }

      if (date_closed_obj && date_closed_obj < date_to_compare) {
        return;
      }

      // if (stage && stage[0] == 5){
      //   return;
      // }

      // if (is_won == 'Closing') {
      //   return;
      // }

      if (country) {
        if (country[1] in ret_dict) {
          ret_dict[country[1]] += 1;
        } else {
          ret_dict["ROW"] += 1;
        }
      }
    });

    ret_dict["Total"] = dict_to_sum(ret_dict);

    return ret_dict;
  }

  export function calc_open_leads_per_country(months, countires, crm_lead_all, date_start, date_end) {
    let ret_dict = {};

    let date_to_compare = date_end;

    if (date_to_compare > new Date()) {
      date_to_compare = new Date();
    }

    countires.forEach((c) => {
      ret_dict[c["long"]] = 0;
    });

    crm_lead_all.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["create_date"]);
      var create_date_str = element["create_date"].substring(0, 7);
      var source = element["source_id"][1];
      var source_category = element["source_category"];
      var type = element["type"];
      var is_won = element["is_won"];
      var sold_boli = element["sum_of_boli_sold_overall"];
      var date_conversion = element["date_conversion"];
      var date_closed = element["date_closed"];
      var country = element["country_id"];
      var date_closed_obj;
      var date_conversion_obj;

      if (!is_country_checked(countires, country[1])) {
        return;
      }

      if (type != "lead") {
        return;
      }

      if (create_date > date_to_compare) {
        return;
      }

      if (date_closed) {
        date_closed_obj = new Date(date_closed);
      } else {
        date_closed_obj = false;
      }

      if (date_conversion) {
        date_conversion_obj = new Date(date_conversion);
      } else {
        date_conversion_obj = false;
      }

      if (date_closed_obj && date_closed_obj < date_to_compare) {
        return;
      }

      if (date_conversion_obj && date_conversion_obj < date_to_compare) {
        return;
      }

      if (country) {
        if (country[1] in ret_dict) {
          ret_dict[country[1]] += 1;
        } else {
          ret_dict["ROW"] += 1;
        }
      }
    });

    ret_dict["Total"] = dict_to_sum(ret_dict);

    return ret_dict;
  }

  function substract_year_from_month_string(month) {
    var year_int = parseInt(month.split("-")[0]);

    return (year_int - 1).toString() + "-" + month.split("-")[1];
  }

  export function calc_management_leads_per_country_per_month(
    months,
    countires,
    lost_leads,
    crm_lead_all,
    lost_opportunities,
    archived,
    date_start_t,
    date_end_t,
    substract_one_year = false
  ) {
    let ret_dict = {};

    var date_start = new Date(date_start_t);
    var date_end = new Date(date_end_t);

    if (substract_one_year) {
      date_start.setFullYear(date_start.getFullYear() - 1);
      date_end.setFullYear(date_end.getFullYear() - 1);
    }

    countires.forEach((c) => {
      ret_dict[c["long"]] = {};

      months.forEach((m) => {
        if (!substract_one_year) {
          ret_dict[c["long"]][m] = 0;
        } else {
          ret_dict[c["long"]][substract_year_from_month_string(m)] = 0;
        }
      });
    });

    crm_lead_all.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["create_date"]);
      var create_date_str = element["create_date"].substring(0, 7);
      var source = element["source_id"][1];
      var source_category = element["source_category"];
      var type = element["type"];
      var is_won = element["is_won"];
      var sold_boli = element["sum_of_boli_sold_overall"];
      var date_conversion = element["date_conversion"];
      var country = element["country_id"];

      if (!is_country_checked(countires, country[1])) {
        return;
      }

      if (create_date >= date_start && create_date <= date_end) {
        if (country[1] in ret_dict) {
          ret_dict[country[1]][create_date_str] += 1;
        } else {
          ret_dict["ROW"][create_date_str] += 1;
        }
      }
    });

    lost_leads.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["x_date_creation"]);
      var create_date_str = element["x_date_creation"].substring(0, 7);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var date_closed = element["x_date_closed"];
      var country = element["x_country_id"];

      if (!is_country_checked(countires, country[1])) {
        return;
      }

      if (country && create_date >= date_start && create_date <= date_end) {
        if (country[1] in ret_dict) {
          ret_dict[country[1]][create_date_str] += 1;
        } else {
          ret_dict["ROW"][create_date_str] += 1;
        }
      }
    });

    lost_opportunities.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["x_date_creation"]);
      var create_date_str = element["x_date_creation"].substring(0, 7);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var date_conversion = element["x_date_conversion"];
      var country = element["x_country_id"];

      if (!is_country_checked(countires, country[1])) {
        return;
      }

      if (country && create_date >= date_start && create_date <= date_end) {
        if (country[1] in ret_dict) {
          ret_dict[country[1]][create_date_str] += 1;
        } else {
          ret_dict["ROW"][create_date_str] += 1;
        }
      }
    });
    archived.forEach((val) => {
      var element = 1 in val ? val[1] : val;
      var create_date = new Date(element["x_date_creation"]);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var create_date_str = element["x_date_creation"].substring(0, 7);
      var country = element["x_country_id"];

      if (!is_country_checked(countires, country[1])) {
        return;
      }

      if (country && create_date >= date_start && create_date <= date_end) {
        if (country[1] in ret_dict) {
          ret_dict[country[1]][create_date_str] += 1;
        } else {
          ret_dict["ROW"][create_date_str] += 1;
        }
      }
    });

    return ret_dict;
  }
  export function calc_management_clients_per_country_per_month(months, countires, res_partner_all) {
    let ret_dict = {};

    countires.forEach((c) => {
      ret_dict[c["long"]] = {};

      months.forEach((m) => {
        ret_dict[c["long"]][m] = 0;
      });
    });

    res_partner_all.forEach((element) => {
      var first_order_date = element[1]["first_order_date"];
      var active = element[1]["active"];

      var company_type = element[1]["company_type"];

      if (company_type != "company") {
        return;
      }

      if (!element[1]["country_id"]) {
        return;
      }
      var country = element[1]["country_id"][1];

      if (!is_country_checked(countires, country)) {
        return;
      }

      var date_to_use = first_order_date;

      if (element[1]["x_studio_kunde_seit"]) {
        var date_obj_element_kunde_seit = new Date(element[1]["x_studio_kunde_seit"]);
        if (element[1]["first_order_date"]) {
          var date_obj_first_order_date = new Date(element[1]["first_order_date"]);
          if (date_obj_element_kunde_seit < date_obj_first_order_date) {
            date_to_use = element[1]["x_studio_kunde_seit"];
          }
        } else {
          date_to_use = element[1]["x_studio_kunde_seit"];
        }
      }
      if (country in ret_dict) {
        if (active && date_to_use && date_to_use.substring(0, 7) in ret_dict[country]) {
          ret_dict[country][date_to_use.substring(0, 7)] += 1;
        }
      } else {
        if (active && date_to_use && date_to_use.substring(0, 7) in ret_dict["ROW"]) {
          ret_dict["ROW"][date_to_use.substring(0, 7)] += 1;
        }
      }
    });
    return ret_dict;
  }
  export function calc_management_sold_boli_per_country_per_month(
    months,
    countires,
    sale_order_all,
    marketing_start_date,
    marketing_end_date
  ) {
    let ret_dict = {};

    countires.forEach((c) => {
      ret_dict[c["long"]] = {};

      months.forEach((m) => {
        ret_dict[c["long"]][m] = 0;
      });
    });

    sale_order_all.forEach((sale) => {
      var obj = sale[1];
      var order_date = get_date_or_null(obj, "x_studio_order_date_mw");

      var product_amount = get_field_if_exists(obj, "product__amount");
      var state = get_field_if_exists(obj, "state");
      var salesman = get_field_if_exists(obj, "salesman_id");

      // if (!obj['country']) {
      //   return;
      // }
      var country = obj["country"];

      if (!is_country_checked(countires, country)) {
        return;
      }

      if (!(obj["price_total"] > 0)) {
        return;
      }

      if (obj["partner"]) {
        if (obj["partner"][1].toLowerCase().includes("smaxtec".toLowerCase())) {
          return;
        }
      }

      if (obj["product_type"] != "Sales Product / Classic Bolus") {
        return;
      }

      if (order_date && product_amount > 0 && (state == "done" || state == "sale")) {
        var order_date_str = obj["x_studio_order_date_mw"].substring(0, 7);

        if (country in ret_dict) {
          if (order_date_str in ret_dict[country]) {
            ret_dict[country][order_date_str] += product_amount;
          }
        } else {
          if (order_date_str in ret_dict["ROW"]) {
            ret_dict["ROW"][order_date_str] += product_amount;
          }
        }
      }
    });

    return ret_dict;
  }
  export function calc_management_opportunities_per_country_per_month(
    months,
    countires,
    lost_leads,
    crm_lead_all,
    lost_opportunities,
    archived,
    date_start,
    date_end
  ) {
    let ret_dict = {};

    countires.forEach((c) => {
      ret_dict[c["long"]] = {};

      months.forEach((m) => {
        ret_dict[c["long"]][m] = 0;
      });
    });

    crm_lead_all.forEach((val) => {
      var element = 1 in val ? val[1] : val;
      var type = element["type"];
      var date_conversion = new Date(element["date_conversion"]);

      var country = element["country_id"];

      if (!is_country_checked(countires, country[1])) {
        return;
      }

      if (type != "opportunity" || !element["date_conversion"]) {
        return;
      }

      var date_conversion_str = element["date_conversion"].substring(0, 7);

      if (country && date_conversion >= date_start && date_conversion <= date_end) {
        if (country[1] in ret_dict) {
          ret_dict[country[1]][date_conversion_str] += 1;
        } else {
          ret_dict["ROW"][date_conversion_str] += 1;
        }
      }
    });

    lost_opportunities.forEach((val) => {
      var element = 1 in val ? val[1] : val;
      var type = element["x_type"];
      var date_conversion = new Date(element["x_date_conversion"]);
      var country = element["x_country_id"];

      if (!is_country_checked(countires, country[1])) {
        return;
      }

      if (type != "opportunity" || !element["x_date_conversion"]) {
        return;
      }

      var date_conversion_str = element["x_date_conversion"].substring(0, 7);

      if (country && date_conversion >= date_start && date_conversion <= date_end) {
        if (country[1] in ret_dict) {
          ret_dict[country[1]][date_conversion_str] += 1;
        } else {
          ret_dict["ROW"][date_conversion_str] += 1;
        }
      }
    });

    archived.forEach((val) => {
      var element = 1 in val ? val[1] : val;
      var create_date = new Date(element["x_date_creation"]);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var create_date_str = element["x_date_creation"].substring(0, 7);
      var country = element["x_country_id"];
      var date_conversion = new Date(element["x_date_conversion"]);

      if (!is_country_checked(countires, country[1])) {
        return;
      }

      if (type != "opportunity" || !element["x_date_conversion"]) {
        return;
      }

      var date_conversion_str = element["x_date_conversion"].substring(0, 7);

      if (country && date_conversion >= date_start && date_conversion <= date_end) {
        if (country[1] in ret_dict) {
          ret_dict[country[1]][date_conversion_str] += 1;
        } else {
          ret_dict["ROW"][date_conversion_str] += 1;
        }
      }
    });

    return ret_dict;
  }

  export function get_country_checked(country_str, laender_dict) {
    let laender_index_dict = {
      Austria: 0,
      Netherlands: 1,
      "United Kingdom": 2,
      Australia: 3,
      "United States": 4,
      Germany: 5,
      Denmark: 6,
      Ireland: 7,
      "New Zealand": 8,
      Switzerland: 9,
    };

    var index;
    if (country_str in laender_index_dict) {
      index = laender_index_dict[country_str];
    } else {
      index = Object.values(laender_index_dict).length;
    }

    return laender_dict[index]["checked"];
  }

  export function calc_balken_progress_table_opps(
    months,
    lost_leads,
    crm_lead_all,
    lost_opportunities,
    archived,
    date_start,
    date_end,
    source_cat_dict,
    laender_dict
  ) {
    let ret_dict = {};

    months.forEach((m) => {
      ret_dict[m] = 0;
    });

    crm_lead_all.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["create_date"]);
      var create_date_str = element["create_date"].substring(0, 7);
      var source = element["source_id"][1];
      var source_category = element["source_category"];
      var type = element["type"];
      var is_won = element["is_won"];
      var sold_boli = element["sum_of_boli_sold_overall"];
      var date_conversion = element["date_conversion"];

      if (type != "opportunity") {
        return;
      }

      if (!source_category) {
        return;
      }

      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }
      var country = element["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (date_conversion && months.includes(date_conversion.substring(0, 7))) {
        ret_dict[date_conversion.substring(0, 7)] += 1;
      }
    });

    lost_opportunities.forEach((element) => {
      var create_date = new Date(element["x_date_creation"]);
      var create_date_str = element["x_date_creation"].substring(0, 7);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var date_conversion = element["x_date_conversion"];

      if (!source_category) {
        return;
      }

      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }
      var country = element["country"];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (date_conversion && months.includes(date_conversion.substring(0, 7))) {
        ret_dict[date_conversion.substring(0, 7)] += 1;
      }
    });

    archived.forEach((val) => {
      var element = 1 in val ? val[1] : val;
      var create_date = new Date(element["x_date_creation"]);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var create_date_str = element["x_date_creation"].substring(0, 7);
      var date_conversion = element["x_date_conversion"];

      if (type != "opportunity" || !date_conversion) {
        return;
      }

      if (!source_category) {
        return;
      }

      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }

      if (!element["x_country_id"]) {
        return;
      }
      var country = element["x_country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }
      if (date_conversion && months.includes(date_conversion.substring(0, 7))) {
        ret_dict[date_conversion.substring(0, 7)] += 1;
      }
    });

    return ret_dict;
  }

  export function get_month_start_from_key(key) {
    return new Date(key + "-01");
  }

  export function get_month_end_from_key(key) {
    var month_start = get_month_start_from_key(key);
    month_start.setMonth(month_start.getMonth() + 1);
    month_start.setDate(month_start.getDate() - 1);

    return month_start;
  }

  export function get_last_not_undefined(data) {
    var value = 0;
    data.forEach((d) => {
      if (typeof d !== "undefined") {
        value = d;
      }
    });
    return value;
  }

  export function calculate_target_clv(
    months,
    active_animals_target,
    hw,
    saas,
    infrastructure_revenue,
    clv_churn_rate,
    useful_life_infrastructure,
    useful_life_bolus
  ) {
    let ret_dict = {};

    months.forEach((m) => {
      // var x = (active_animals_target * (saas[m] + hw[m] + infrastructure_revenue[m])) / (clv_churn_rate[m] / 10);

      var x =
        (active_animals_target * (saas[m] + hw[m] / useful_life_bolus + infrastructure_revenue[m] / useful_life_infrastructure)) /
        (clv_churn_rate[m] / (12 * 100));

      if (!isNaN(x)) {
        ret_dict[m] = x;
      } else {
        ret_dict[m] = undefined;
      }
    });

    return ret_dict;
  }

  export function get_marketing_target(months, targets, key) {
    let ret_dict = {};

    targets.forEach((t) => {
      months.forEach((m) => {
        if (t["start_date"] && t["start_date"].substring(0, 4) == m.substring(0, 4).toString()) {
          if (t["name"].includes(key)) {
            ret_dict[m] = t["target_goal"];
          }
        }
      });
    });

    return ret_dict;
  }

  export function get_clv_target(months, clv_targets, key) {
    let ret_dict = {};

    months.forEach((m) => {
      clv_targets.forEach((t) => {
        if (t[0] == key) {
          t[1].forEach((tl) => {
            var start_date = new Date(tl["start_date"]);
            var end_date = new Date(tl["end_date"]);
            var compare = new Date(m + "-15");
            if (compare >= start_date && compare <= end_date) {
              ret_dict[m] = tl["target_goal"];
            }
          });
        }
      });
    });

    return ret_dict;
  }

  //TODO nur kopiert macht noch nicht was es soll
  export function calc_open_opps_per_month(crm_lead_all, lost_opportunities, months, laender_dict, source_cat_dict, start_date, end_date) {
    var sum = 0;

    let source_cate_index_dict = {
      Advertising: 0,
      Events: 1,
      Organic: 2,
      Sales: 3,
    };

    crm_lead_all.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["create_date"]);
      var source_category = element["source_category"];
      var date_conversion = element["date_conversion"];
      var date_closed = element["date_closed"];

      if (!source_category) {
        return;
      }
      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }
      if (new Date(create_date) > end_date) {
        return;
      }
      if (date_conversion && date_conversion < start_date) {
        return;
      }
      if (date_closed && date_closed < start_date) {
        return;
      }
      var country = element["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }
      sum = sum + 1;
    });

    lost_opportunities.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["x_date_creation"]);
      var source_category = element["source_category"];
      var date_conversion = element["x_date_conversion"];
      var date_closed = element["x_date_closed"];

      if (!source_category) {
        return;
      }
      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }
      if (new Date(create_date) > end_date) {
        return;
      }
      if (date_conversion && date_conversion < start_date) {
        return;
      }
      if (date_closed && date_closed < start_date) {
        return;
      }
      var country = element["country"];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }
      sum = sum + 1;
    });

    return sum;
  }

  export function calc_open_leads_per_month(
    crm_lead_all,
    lost_leads,
    lost_opportunities,
    archived,
    months,
    laender_dict,
    source_cat_dict,
    start_date,
    end_date
  ) {
    let ret_dict = {};

    months.forEach((m) => {
      ret_dict[m] = calc_open_leads(
        crm_lead_all,
        lost_leads,
        lost_opportunities,
        archived,
        m,
        laender_dict,
        source_cat_dict,
        get_month_start_from_key(m),
        get_month_end_from_key(m)
      );
    });

    return ret_dict;
  }

  function day_of_year(date) {
    var now = date;
    var start = new Date(now.getFullYear(), 0, 0);
    var diff = now - start;
    var oneDay = 1000 * 60 * 60 * 24;
    var day = Math.floor(diff / oneDay);

    return day;
  }

  export function nur_aktuelle_monate(year, months, dict) {
    if (year != new Date().getFullYear()) {
      return dict_to_sum(dict);
    } else {
      var sum = 0;
      months.forEach((m) => {
        var monat = parseInt(m.split("-")[1]) - 1;
        if (monat <= new Date().getMonth()) {
          sum = sum + dict[m];
        }
      });
      return sum;
    }
  }

  export function target_runterbrechen(year, target) {
    var current_day_of_year = day_of_year(new Date());
    if (year == new Date().getFullYear()) {
      return target * (current_day_of_year / 365);
    } else {
      return target;
    }
  }

  export function current_hochrechnen(data, months) {
    let ret_dict = {};

    if (months[0].substring(0, 4) != new Date().getFullYear().toString()) {
      return dict_to_sum(data);
    }

    var sum = 0;
    months.forEach((m) => {
      var month = parseInt(m.substring(5, 7));
      if (month <= new Date().getMonth() + 1) {
        sum = sum + data[m];
      }
    });

    var current_day_of_year = day_of_year(new Date());

    return sum * (1 / (current_day_of_year / 365));
  }

  export function filter_revenue(revenue, months) {
    let ret_dict = {};

    months.forEach((m) => {
      revenue.forEach((val) => {
        if (m == val["Month"]) {
          ret_dict[val["Month"]] = val["Revenue"];
        }
      });
    });

    return ret_dict;
  }

  export function calc_open_leads(
    crm_lead_all,
    lost_leads,
    lost_opportunities,
    archived,
    months,
    laender_dict,
    source_cat_dict,
    start_date,
    end_date
  ) {
    var sum = 0;

    let source_cate_index_dict = {
      Advertising: 0,
      Events: 1,
      Organic: 2,
      Sales: 3,
    };

    crm_lead_all.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["create_date"]);
      var source_category = element["source_category"];
      var date_conversion = element["date_conversion"];
      var date_closed = element["date_closed"];

      if (!source_category) {
        return;
      }
      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }
      if (new Date(create_date) > end_date) {
        return;
      }
      if (date_conversion && date_conversion < start_date) {
        return;
      }
      if (date_closed && date_closed < start_date) {
        return;
      }
      var country = element["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }
      sum = sum + 1;
    });

    lost_leads.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["x_date_creation"]);
      var source_category = element["source_category"];
      var date_conversion = element["x_date_conversion"];
      var date_closed = element["x_date_closed"];

      if (!source_category) {
        return;
      }
      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }
      if (new Date(create_date) > end_date) {
        return;
      }
      if (date_conversion && date_conversion < start_date) {
        return;
      }
      if (date_closed && date_closed < start_date) {
        return;
      }
      var country = element["country"];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }
      sum = sum + 1;
    });

    lost_opportunities.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["x_date_creation"]);
      var source_category = element["source_category"];
      var date_conversion = element["x_date_conversion"];
      var date_closed = element["x_date_closed"];

      if (!source_category) {
        return;
      }
      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }
      if (new Date(create_date) > end_date) {
        return;
      }
      if (date_conversion && date_conversion < start_date) {
        return;
      }
      if (date_closed && date_closed < start_date) {
        return;
      }
      var country = element["country"];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }
      sum = sum + 1;
    });

    archived.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["x_date_creation"]);
      var source_category = element["source_category"];
      var date_conversion = element["x_date_conversion"];
      var date_closed = element["x_date_closed"];

      if (!source_category) {
        return;
      }
      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }
      if (new Date(create_date) > end_date) {
        return;
      }
      if (date_conversion && date_conversion < start_date) {
        return;
      }
      if (date_closed && date_closed < start_date) {
        return;
      }
      var country = element["country"];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }
      sum = sum + 1;
    });

    return sum;
  }

  export function calc_all_open_leads(
    crm_lead_all,
    lost_leads,
    lost_opportunities,
    archived,
    months,
    laender_dict,
    source_cat_dict,
    start_date,
    end_date
  ) {
    var sum = 0;

    let source_cate_index_dict = {
      Advertising: 0,
      Events: 1,
      Organic: 2,
      Sales: 3,
    };

    crm_lead_all.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["create_date"]);
      var source_category = element["source_category"];
      var date_conversion = element["date_conversion"];
      var date_closed = element["date_closed"];
      var last_stage_update = element["date_last_stage_update"];
      var stage_entry = element["stage_id"];
      var source = element["source_id"];
      var stage_name = false;
      if (stage_entry) {
        stage_name = stage_entry[1];
      }

      if (!source_category) {
        return;
      }
      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }
      if (new Date(create_date) > end_date) {
        return;
      }

      if (date_closed && date_closed < start_date) {
        return;
      }

      if (stage_name && stage_name == "Gewonnen") {
        if (last_stage_update) {
          if (new Date(last_stage_update) < start_date) {
            return;
          }
        }
      }

      var country = element["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      sum = sum + 1;
    });

    // console.log('Zwichensumme all open leads nicht lost: ', sum);

    lost_leads.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["x_date_creation"]);
      var source_category = element["source_category"];
      var date_conversion = element["x_date_conversion"];
      var date_closed = element["x_date_closed"];

      if (!source_category) {
        return;
      }
      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }
      if (new Date(create_date) > end_date) {
        return;
      }

      if (date_closed && date_closed < start_date) {
        return;
      }
      var country = element["country"];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }
      sum = sum + 1;
    });

    lost_opportunities.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["x_date_creation"]);
      var source_category = element["source_category"];
      var date_conversion = element["x_date_conversion"];
      var date_closed = element["x_date_closed"];

      if (!source_category) {
        return;
      }
      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }
      if (new Date(create_date) > end_date) {
        return;
      }

      if (date_closed && date_closed < start_date) {
        return;
      }
      var country = element["country"];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }
      sum = sum + 1;
    });

    archived.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["x_date_creation"]);
      var source_category = element["source_category"];
      var date_conversion = element["x_date_conversion"];
      var date_closed = element["x_date_closed"];

      if (!source_category) {
        return;
      }
      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }
      if (new Date(create_date) > end_date) {
        return;
      }

      if (date_closed && date_closed < start_date) {
        return;
      }
      var country = element["country"];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }
      sum = sum + 1;
    });

    return sum;
  }

  export function calc_time_lead_to_customer(crm_lead_all, months, laender_dict, source_cat_dict) {
    var sum = 0;
    var customers_checked = 0;

    let source_cate_index_dict = {
      Advertising: 0,
      Events: 1,
      Organic: 2,
      Sales: 3,
    };

    crm_lead_all.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["create_date"]);
      var create_date_str = element["create_date"].substring(0, 7);
      var source = element["source_id"][1];
      var source_category = element["source_category"];
      var type = element["type"];
      var is_won = element["is_won"];
      var sold_boli = element["sum_of_boli_sold_overall"];
      var date_conversion = element["date_conversion"];
      var date_closed = element["date_closed"];
      var partner__first_order_date = element["partner__first_order_date"];

      if (type != "opportunity") {
        return;
      }

      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }

      if (!is_won) {
        return;
      }

      var country = element["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (!partner__first_order_date) {
        return;
      }

      if (!months.includes(partner__first_order_date.substring(0, 7))) {
        return;
      }

      sum = sum + get_difference_in_days(create_date, new Date(partner__first_order_date));
      customers_checked = customers_checked + 1;
    });

    return sum / customers_checked;
  }

  export function calc_lost_opp_number(lost_opps, months, laender_dict, source_cat_dict) {
    var lost_opps_number = 0;

    let source_cate_index_dict = {
      Advertising: 0,
      Events: 1,
      Organic: 2,
      Sales: 3,
    };

    lost_opps.forEach((element) => {
      var create_date = new Date(element["x_date_creation"]);
      var create_date_str = element["x_date_creation"].substring(0, 7);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var date_closed = element["x_date_closed"];
      var lost_reason = element["x_lost_reason"];
      var date_last_stage_update = element["x_date_last_stage_update"];

      var country = element["country"];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (type != "opportunity") {
        return;
      }

      if (!lost_reason) {
        return;
      }

      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }

      if (date_closed && months.includes(date_closed.substring(0, 7))) {
        lost_opps_number = lost_opps_number + 1;
      }
    });

    return lost_opps_number;
  }

  export function calc_open_leads_in_timeframe(crm_lead_all, marketing_start_date, marketing_end_date) {
    crm_lead_all.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["create_date"]);
    });

    return 1;
  }

  export function calc_lost_lead_number(lost_leads, months, laender_dict, source_cat_dict) {
    var lost_leads_number = 0;

    let source_cate_index_dict = {
      Advertising: 0,
      Events: 1,
      Organic: 2,
      Sales: 3,
    };

    lost_leads.forEach((element) => {
      var create_date = new Date(element["x_date_creation"]);
      var create_date_str = element["x_date_creation"].substring(0, 7);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var date_closed = element["x_date_closed"];
      var date_last_stage_update = element["x_date_last_stage_update"];

      var country = element["country"];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (type != "lead") {
        return;
      }
      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }

      if (date_closed && months.includes(date_closed.substring(0, 7))) {
        lost_leads_number = lost_leads_number + 1;
      } else {
        // console.log("no date_closed: ", element)
      }
    });

    return lost_leads_number;
  }

  export function calc_all_open_opps(crm_lead_all, lost_opportunities, months, laender_dict, source_cat_dict, start_date, end_date) {
    var sum = 0;

    let source_cate_index_dict = {
      Advertising: 0,
      Events: 1,
      Organic: 2,
      Sales: 3,
    };

    crm_lead_all.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["create_date"]);
      var create_date_str = element["create_date"].substring(0, 7);
      var source = element["source_id"][1];
      var source_category = element["source_category"];
      var type = element["type"];
      var is_won = element["is_won"];
      var sold_boli = element["sum_of_boli_sold_overall"];
      var date_conversion = element["date_conversion"];
      var date_closed = element["date_closed"];
      var partner__first_order_date = element["partner__first_order_date"];

      var last_stage_update = element["date_last_stage_update"];
      var stage_entry = element["stage_id"];
      var stage_name = false;
      if (stage_entry) {
        stage_name = stage_entry[1];
      }

      if (type != "opportunity") {
        return;
      }

      if (create_date > end_date) {
        return;
      }

      if (date_conversion && new Date(date_conversion) > end_date) {
        return;
      }

      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }

      // if (is_won) {
      //   return;
      // }

      var country = element["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      // if (partner__first_order_date && new Date(partner__first_order_date) < start_date) {
      //   return;
      // }

      if (stage_name && stage_name == "Gewonnen") {
        if (last_stage_update) {
          if (new Date(last_stage_update) < start_date) {
            return;
          }
        }
      }

      // console.log("element in all open opp: ", element)
      sum = sum + 1;
    });

    lost_opportunities.forEach((element) => {
      var create_date = new Date(element["x_date_creation"]);
      var create_date_str = element["x_date_creation"].substring(0, 7);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var date_conversion = element["x_date_conversion"];
      var date_closed = element["x_date_closed"];

      if (type != "opportunity") {
        return;
      }

      if (create_date > end_date) {
        return;
      }

      if (date_conversion && new Date(date_conversion) > end_date) {
        return;
      }

      if (date_closed && new Date(date_closed) < start_date) {
        return;
      }

      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }

      // if (is_won) {
      //   return;
      // }

      var country = element["x_country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      sum += 1;
    });

    // console.log('endsumme open opps: ', sum);

    return sum;
  }

  export function calc_open_opps(crm_lead_all, lost_opportunities, months, laender_dict, source_cat_dict, start_date, end_date) {
    var sum = 0;

    let source_cate_index_dict = {
      Advertising: 0,
      Events: 1,
      Organic: 2,
      Sales: 3,
    };

    crm_lead_all.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["create_date"]);
      var create_date_str = element["create_date"].substring(0, 7);
      var source = element["source_id"][1];
      var source_category = element["source_category"];
      var type = element["type"];
      var is_won = element["is_won"];
      var sold_boli = element["sum_of_boli_sold_overall"];
      var date_conversion = element["date_conversion"];
      var date_closed = element["date_closed"];
      var partner__first_order_date = element["partner__first_order_date"];

      if (type != "opportunity") {
        return;
      }

      if (create_date > end_date) {
        return;
      }

      if (date_conversion && new Date(date_conversion) > end_date) {
        return;
      }

      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }

      if (is_won) {
        return;
      }

      var country = element["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (partner__first_order_date && new Date(partner__first_order_date) < start_date) {
        return;
      }

      sum = sum + 1;
    });

    lost_opportunities.forEach((element) => {
      var create_date = new Date(element["x_date_creation"]);
      var create_date_str = element["x_date_creation"].substring(0, 7);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var date_conversion = element["x_date_conversion"];
    });

    return sum;
  }

  export function calc_balken_progress_table_leads(
    months,
    lost_leads,
    crm_lead_all,
    lost_opportunities,
    archived,
    date_start,
    date_end,
    source_cat_dict,
    laender_dict
  ) {
    let ret_dict = {};

    months.forEach((m) => {
      ret_dict[m] = 0;
    });

    crm_lead_all.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      var create_date = new Date(element["create_date"]);
      var create_date_str = element["create_date"].substring(0, 7);
      var source = element["source_id"][1];
      var source_category = element["source_category"];
      var type = element["type"];
      var is_won = element["is_won"];
      var sold_boli = element["sum_of_boli_sold_overall"];
      var date_conversion = element["date_conversion"];

      if (!source_category) {
        return;
      }

      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }
      var country = element["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (create_date >= date_start && create_date <= date_end) {
        ret_dict[create_date_str] += 1;
      }
    });

    lost_leads.forEach((val) => {
      var element = 1 in val ? val[1] : val;
      var create_date = new Date(element["x_date_creation"]);
      var create_date_str = element["x_date_creation"].substring(0, 7);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var date_closed = element["x_date_closed"];

      if (!source_category) {
        return;
      }

      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }
      var country = element["country"];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (create_date >= date_start && create_date <= date_end) {
        ret_dict[create_date_str] += 1;
      }
    });

    lost_opportunities.forEach((val) => {
      var element = 1 in val ? val[1] : val;
      var create_date = new Date(element["x_date_creation"]);
      var create_date_str = element["x_date_creation"].substring(0, 7);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var date_conversion = element["x_date_conversion"];

      if (!source_category) {
        return;
      }

      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }
      var country = element["country"];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (create_date >= date_start && create_date <= date_end) {
        ret_dict[create_date_str] += 1;
      }
    });

    archived.forEach((val) => {
      var element = 1 in val ? val[1] : val;
      var create_date = new Date(element["x_date_creation"]);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var create_date_str = element["x_date_creation"].substring(0, 7);

      if (!source_category) {
        return;
      }

      if (source_cat_dict[source_cate_index_dict[source_category]]["checked"] == false) {
        return;
      }

      if (!element["x_country_id"]) {
        return;
      }
      var country = element["x_country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }
      if (create_date >= date_start && create_date <= date_end) {
        ret_dict[create_date_str] += 1;
      }
    });

    return ret_dict;
  }

  export function calc_balken_progress_table_clients(months, res_partner_all, laender_dict, exclude_sales = true) {
    let ret_dict = {};

    months.forEach((m) => {
      ret_dict[m] = 0;
    });

    res_partner_all.forEach((element) => {
      var first_order_date = element[1]["first_order_date"];
      var active = element[1]["active"];
      var company_type = element[1]["company_type"];

      if (company_type != "company") {
        return;
      }

      if (!element[1]["country_id"]) {
        return;
      }
      var country = element[1]["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      var date_to_use = first_order_date;

      if (element[1]["x_studio_kunde_seit"]) {
        var date_obj_element_kunde_seit = new Date(element[1]["x_studio_kunde_seit"]);
        if (element[1]["first_order_date"]) {
          var date_obj_first_order_date = new Date(element[1]["first_order_date"]);
          if (date_obj_element_kunde_seit < date_obj_first_order_date) {
            date_to_use = element[1]["x_studio_kunde_seit"];
          }
        } else {
          date_to_use = element[1]["x_studio_kunde_seit"];
        }
      }
      if (active && date_to_use && date_to_use.substring(0, 7) in ret_dict) {
        ret_dict[date_to_use.substring(0, 7)] += 1;
        if (element[1]["country_id"][1] == "New Zealand") {
          // console.log("alt element: ", element[1])
        }
      }
    });
    return ret_dict;
  }

  export function filter_keys(dict, keys) {
    let ret_dict = {};

    keys.forEach((k) => {
      ret_dict[k] = dict[k];
    });

    return ret_dict;
  }

  export function add_boli_churn(animals_table_values, lost_boli_per_country_per_month, laender_dict, months) {
    animals_table_values["boli_churn"] = {};
    laender_dict.forEach((l) => {
      animals_table_values["boli_churn"][l["long"]] = {};
      months.forEach((m) => {
        animals_table_values["boli_churn"][l["long"]][m] = lost_boli_per_country_per_month[l["long"]][m];
      });
    });
  }

  export function substract_dict(pre_months, active_boli_basis_per_country, table_active_boli_deactivated_animals_per_country_pre_month) {
    pre_months.forEach((m) => {
      active_boli_basis_per_country[m] = active_boli_basis_per_country[m] - table_active_boli_deactivated_animals_per_country_pre_month[m];
    });
  }

  export function remove_deactivated_from_basis(
    pre_months,
    laender_dict,
    active_boli_basis_per_country,
    table_active_boli_deactivated_animals_per_country_pre_month
  ) {
    laender_dict.forEach((l) => {
      pre_months.forEach((m) => {
        active_boli_basis_per_country[l["long"]][m] =
          active_boli_basis_per_country[l["long"]][m] - table_active_boli_deactivated_animals_per_country_pre_month[l["long"]][m];
      });
    });
  }

  export function calc_balken_progress_table_lost_boli_per_country_per_month(
    months_t,
    res_partner_all,
    subscription_all,
    laender_dict,
    last_year = false
  ) {
    let ret_dict = {};
    let months = [];

    months_t.forEach((m) => {
      if (!last_year) {
        months.push(m);
      } else {
        months.push(substract_year_from_month_string(m));
      }
    });

    laender_dict.forEach((l) => {
      ret_dict[l["long"]] = {};
      months.forEach((m) => {
        ret_dict[l["long"]][m] = 0;
      });
    });

    subscription_all.forEach((val) => {
      var element = 1 in val ? val[1] : val;
      var first_order_date = element["first_order_date"];
      var x_studio_kunde_seit__2 = element["x_studio_kunde_seit__2"];
      var date_to_use = element["date"];

      if (element["close_reason_id"]) {
        if (!element["close_reason_id"][0] == 4 && !element["close_reason_id"][10] == 0) {
          return;
        }
      }

      if (!element["country_id"]) {
        return;
      }
      var country = element["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (date_to_use && months.includes(date_to_use.substring(0, 7))) {
        if (country in ret_dict) {
          ret_dict[country][date_to_use.substring(0, 7)] += element["__boli"];
        } else {
          ret_dict["ROW"][date_to_use.substring(0, 7)] += element["__boli"];
        }
      }
    });

    ret_dict["Total"] = dict_to_sum(ret_dict);

    return ret_dict;
  }

  export function calc_balken_progress_table_lost_boli_per_country(
    months_t,
    res_partner_all,
    subscription_all,
    laender_dict,
    last_year = false
  ) {
    let ret_dict = {};
    var months = [];

    months_t.forEach((m) => {
      if (!last_year) {
        months.push(m);
      } else {
        months.push(substract_year_from_month_string(m));
      }
    });

    laender_dict.forEach((l) => {
      ret_dict[l["long"]] = 0;
    });

    subscription_all.forEach((val) => {
      var element = 1 in val ? val[1] : val;
      var first_order_date = element["first_order_date"];
      var x_studio_kunde_seit__2 = element["x_studio_kunde_seit__2"];
      var date_to_use = element["date"];

      if (element["close_reason_id"]) {
        if (!element["close_reason_id"][0] == 4 && !element["close_reason_id"][10] == 0) {
          return;
        }
      }

      if (!element["country_id"]) {
        return;
      }
      var country = element["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (date_to_use && months.includes(date_to_use.substring(0, 7))) {
        if (country in ret_dict) {
          ret_dict[country] += element["__boli"];
        } else {
          ret_dict["ROW"] += element["__boli"];
        }
      }
    });

    ret_dict["Total"] = dict_to_sum(ret_dict);

    return ret_dict;
  }

  export function calc_balken_progress_table_herd_churn_per_month(
    months_t,
    res_partner_all,
    subscription_all,
    laender_dict,
    last_year = false
  ) {
    let ret_dict = {};
    let months = [];

    months_t.forEach((m) => {
      if (!last_year) {
        months.push(m);
      } else {
        months.push(substract_year_from_month_string(m));
      }
    });

    months.forEach((m) => {
      ret_dict[m] = 0;
    });

    subscription_all.forEach((val) => {
      var element = 1 in val ? val[1] : val;
      var first_order_date = element["first_order_date"];
      var x_studio_kunde_seit__2 = element["x_studio_kunde_seit__2"];
      var date_to_use = element["date"];

      if (element["close_reason_id"]) {
        if (!element["close_reason_id"][0] == 4 && !element["close_reason_id"][10] == 0) {
          return;
        }
      }

      if (!element["country_id"]) {
        return;
      }
      var country = element["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (!element["__boli"]) {
        return;
      }

      if (date_to_use && months.includes(date_to_use.substring(0, 7))) {
        ret_dict[date_to_use.substring(0, 7)] += element["__max_installations"];
      }
    });

    return ret_dict;
  }

  export function calc_balken_progress_table_herd_churn_per_country_per_month(
    months_t,
    res_partner_all,
    subscription_all,
    laender_dict,
    last_year = false
  ) {
    let ret_dict = {};
    let months = [];

    months_t.forEach((m) => {
      if (!last_year) {
        months.push(m);
      } else {
        months.push(substract_year_from_month_string(m));
      }
    });

    laender_dict.forEach((l) => {
      ret_dict[l["long"]] = {};
      months.forEach((m) => {
        ret_dict[l["long"]][m] = 0;
      });
    });

    subscription_all.forEach((val) => {
      var element = 1 in val ? val[1] : val;
      var first_order_date = element["first_order_date"];
      var x_studio_kunde_seit__2 = element["x_studio_kunde_seit__2"];
      var date_to_use = element["date"];

      if (element["close_reason_id"]) {
        if (!element["close_reason_id"][0] == 4 && !element["close_reason_id"][10] == 0) {
          return;
        }
      }

      if (!element["country_id"]) {
        return;
      }
      var country = element["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (!element["__boli"]) {
        return;
      }

      if (date_to_use && months.includes(date_to_use.substring(0, 7))) {
        if (country in ret_dict) {
          if (element["__boli"] && !element["__max_installations"]) {
          }

          // if(country == "Australia"){
          //   console.log("Australia sub: ", element)

          // }

          ret_dict[country][date_to_use.substring(0, 7)] += element["__max_installations"];
        } else {
          ret_dict["ROW"][date_to_use.substring(0, 7)] += element["__max_installations"];
        }
      }
    });

    ret_dict["Total"] = dict_to_sum(ret_dict);

    return ret_dict;
  }

  export function calc_balken_progress_table_lost_boli(months, res_partner_all, subscription_all, laender_dict, exclude_sales = true) {
    let ret_dict = {};

    months.forEach((m) => {
      ret_dict[m] = 0;
    });

    subscription_all.forEach((element) => {
      var first_order_date = element[1]["first_order_date"];
      var x_studio_kunde_seit__2 = element[1]["x_studio_kunde_seit__2"];
      var date_to_use = element[1]["date"];

      if (element[1]["close_reason_id"]) {
        if (!element[1]["close_reason_id"][0] == 4 && !element[1]["close_reason_id"][10] == 0) {
          return;
        }
      }

      if (!element[1]["country_id"]) {
        return;
      }
      var country = element[1]["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (date_to_use && date_to_use.substring(0, 7) in ret_dict) {
        ret_dict[date_to_use.substring(0, 7)] += element[1]["__boli"];
      }
    });
    return ret_dict;
  }

  export function calc_balken_progress_table_lost_clients_per_country(months, res_partner_all, subscription_all, countires) {
    let ret_dict = {};

    countires.forEach((c) => {
      ret_dict[c["long"]] = 0;
    });

    subscription_all.forEach((element) => {
      var first_order_date = element[1]["first_order_date"];
      var x_studio_kunde_seit__2 = element[1]["x_studio_kunde_seit__2"];
      var date_to_use = element[1]["date"];

      if (element[1]["close_reason_id"]) {
        if (!element[1]["close_reason_id"][0] == 4 && !element[1]["close_reason_id"][10] == 0) {
          return;
        }
      }

      if (!element[1]["country_id"]) {
        return;
      }
      var country = element[1]["country_id"][1];
      if (!is_country_checked(countires, country)) {
        return;
      }

      if (!date_to_use) {
        return;
      }

      if (!months.includes(date_to_use.substring(0, 7))) {
        return;
      }

      if (country in ret_dict) {
        ret_dict[country] += 1;
      } else {
        ret_dict["ROW"] += 1;
      }
    });

    ret_dict["Total"] = dict_to_sum(ret_dict);

    return ret_dict;
  }

  export function calc_balken_progress_table_lost_clients(months, res_partner_all, subscription_all, laender_dict, exclude_sales = true) {
    let ret_dict = {};

    months.forEach((m) => {
      ret_dict[m] = 0;
    });

    subscription_all.forEach((element) => {
      var first_order_date = element[1]["first_order_date"];
      var x_studio_kunde_seit__2 = element[1]["x_studio_kunde_seit__2"];
      var date_to_use = element[1]["date"];

      if (element[1]["close_reason_id"]) {
        if (!element[1]["close_reason_id"][0] == 4 && !element[1]["close_reason_id"][10] == 0) {
          return;
        }
      }

      if (!element[1]["country_id"]) {
        return;
      }
      var country = element[1]["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (date_to_use && date_to_use.substring(0, 7) in ret_dict) {
        ret_dict[date_to_use.substring(0, 7)] += 1;
      }
    });
    return ret_dict;
  }

  export function res_partner_filtered_to_dict(res_partner_filtered) {
    let ret_dict = {};

    res_partner_filtered.forEach((element) => {
      ret_dict[element[0]] = element[1];
    });

    return ret_dict;
  }

  export function calc_sold_boli_goals_list(goals_all, months) {
    let ret_dict = {};

    months.forEach((m) => {
      ret_dict[m] = 0;
    });

    goals_all.forEach((g) => {
      var date = g["start_date"];
      var value = g["target_goal"];
      var key = date.substring(0, 7);

      if (g["x_studio_ziel"] && g["x_studio_ziel"].includes("SOLD_BOL_TARGET")) {
        return;
      }

      if (key in ret_dict) {
        ret_dict[key] += value;
      }
    });

    return ret_dict;
  }

  export function calc_balken_progress_table_sold_boli_neu_oder_altkunde(
    months,
    sale_order_all,
    res_partner_dict,
    date_start,
    date_end,
    laender_dict,
    neu_oder_altkunde,
    chosen_months_astrid
  ) {
    let ret_dict = {};

    months.forEach((m) => {
      ret_dict[m] = 0;
    });

    let ret_dict_per_country = {};

    laender_dict.forEach((l) => {
      ret_dict_per_country[l["long"]] = {};
      months.forEach((m) => {
        ret_dict_per_country[l["long"]][m] = 0;
      });
    });
    ret_dict_per_country["ROW"] = {};
    months.forEach((m) => {
      ret_dict_per_country["ROW"][m] = 0;
    });

    sale_order_all.forEach((sale) => {
      var obj = sale[1];
      var order_date = get_date_or_null(obj, "x_studio_order_date_mw");

      var product_amount = get_field_if_exists(obj, "product__amount");
      var state = get_field_if_exists(obj, "state");
      var salesman = get_field_if_exists(obj, "salesman_id");

      //TODO wieder einkommentieren
      // if (!obj['country']) {
      //   return;
      // }
      var country = obj["country"];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (!(obj["price_total"] > 0)) {
        return;
      }

      if (obj["partner"]) {
        if (obj["partner"][1].toLowerCase().includes("smaxtec".toLowerCase())) {
          return;
        }
      }

      if (obj["product_type"] != "Sales Product / Classic Bolus") {
        return;
      }

      var partner_obj = res_partner_dict[obj["partner"][0]];

      if (!(obj["partner"][0] in res_partner_dict)) {
        // console.log("product_amount: ", product_amount)
        // console.log("obj['partner'][0]: ", obj['partner'][0])
        // console.log("sale: ", sale)
        return;
      }

      //get customer since:
      var cust_since = new Date();
      if (partner_obj["x_studio_kunde_seit"]) {
        var date = new Date(partner_obj["x_studio_kunde_seit"]);
        if (date < cust_since) {
          cust_since = date;
        }
      }
      if (partner_obj["first_order_date"]) {
        var date = new Date(partner_obj["first_order_date"]);
        if (date < cust_since) {
          cust_since = date;
        }
      }

      var neukunden_datum = new Date(cust_since);
      neukunden_datum.setMonth(neukunden_datum.getMonth() + chosen_months_astrid);

      //wenn orderdate < (cust_since + 6months) ==> neukunde

      if (order_date && product_amount > 0 && (state == "done" || state == "sale")) {
        var order_date_str = obj["x_studio_order_date_mw"].substring(0, 7);
        if (order_date_str in ret_dict) {
          if (neu_oder_altkunde == "neu") {
            if (neukunden_datum > order_date) {
              ret_dict[order_date_str] += product_amount;

              if (country in ret_dict_per_country) {
                ret_dict_per_country[country][order_date_str] += product_amount;
              } else {
                ret_dict_per_country["ROW"][order_date_str] += product_amount;
              }
            }
          }
          if (neu_oder_altkunde == "alt") {
            if (neukunden_datum <= order_date) {
              ret_dict[order_date_str] += product_amount;

              if (country in ret_dict_per_country) {
                ret_dict_per_country[country][order_date_str] += product_amount;
              } else {
                ret_dict_per_country["ROW"][order_date_str] += product_amount;
              }
            }
          }
        }
      } else {
      }
    });

    return { all: ret_dict, per_country: ret_dict_per_country };
  }

  export function calc_balken_progress_table_sold_boli(months, sale_order_all, date_start, date_end, laender_dict, exclude_sales = true) {
    let ret_dict = {};

    months.forEach((m) => {
      ret_dict[m] = 0;
    });

    sale_order_all.forEach((sale) => {
      var obj = sale[1];
      var order_date = get_date_or_null(obj, "x_studio_order_date_mw");

      var product_amount = get_field_if_exists(obj, "product__amount");
      var state = get_field_if_exists(obj, "state");
      var salesman = get_field_if_exists(obj, "salesman_id");

      //TODO wieder einkommentieren
      // if (!obj['country']) {
      //   return;
      // }
      var country = obj["country"];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (!(obj["price_total"] > 0)) {
        return;
      }

      if (obj["partner"]) {
        if (obj["partner"][1].toLowerCase().includes("smaxtec".toLowerCase())) {
          return;
        }
      }

      if (obj["product_type"] != "Sales Product / Classic Bolus") {
        return;
      }

      if (order_date && product_amount > 0 && (state == "done" || state == "sale")) {
        var order_date_str = obj["x_studio_order_date_mw"].substring(0, 7);
        if (order_date_str in ret_dict) {
          ret_dict[order_date_str] += product_amount;
        }
      } else {
      }
    });

    return ret_dict;
  }

  export function calc_balken_progress_table_active_boli_per_country(months, messenger_res, date_start, date_end, laender_dict) {
    let ret_dict_new_animals = {};

    laender_dict.forEach((l) => {
      ret_dict_new_animals[l["long"]] = 0;
    });

    let ret_dict_active_animals = {};

    laender_dict.forEach((l) => {
      ret_dict_active_animals[l["long"]] = 0;
    });

    let ret_dict_deactivated_animals = {};

    laender_dict.forEach((l) => {
      ret_dict_deactivated_animals[l["long"]] = 0;
    });

    let ret_dict_remounted_animals = {};

    laender_dict.forEach((l) => {
      ret_dict_remounted_animals[l["long"]] = 0;
    });

    messenger_res.forEach((messenger) => {
      var obj = messenger[1];
      var date = obj["date"];
      var new_animals = obj["new_animals"];
      var active_animals = obj["active_animals"];
      var deactivated_animals = obj["inactive_animals"];
      var remounted_animals = obj["remounted_animals"];

      if (!obj["x_studio_country"]) {
        return;
      }
      var country = obj["x_studio_country"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (!(date && new Date(date) <= date_end && new Date(date) >= date_start)) {
        return;
      }

      if (country in ret_dict_new_animals) {
        ret_dict_new_animals[country] += new_animals;
      } else {
        ret_dict_new_animals["ROW"] += new_animals;
      }
      if (country in ret_dict_active_animals) {
        ret_dict_active_animals[country] += active_animals;
      } else {
        ret_dict_active_animals["ROW"] += active_animals;
      }
      if (country in ret_dict_active_animals) {
        ret_dict_deactivated_animals[country] += deactivated_animals;
      } else {
        ret_dict_deactivated_animals["ROW"] += deactivated_animals;
      }
      if (country in ret_dict_remounted_animals) {
        ret_dict_remounted_animals[country] += remounted_animals;
      } else {
        ret_dict_remounted_animals["ROW"] += remounted_animals;
      }
    });

    ret_dict_new_animals["Total"] = dict_to_sum(ret_dict_new_animals);
    ret_dict_active_animals["Total"] = dict_to_sum(ret_dict_active_animals);
    ret_dict_deactivated_animals["Total"] = dict_to_sum(ret_dict_deactivated_animals);
    ret_dict_remounted_animals["Total"] = dict_to_sum(ret_dict_remounted_animals);

    return {
      new_animals: ret_dict_new_animals,
      active_animals: ret_dict_active_animals,
      deactivated_animals: ret_dict_deactivated_animals,
      remounted_animals: ret_dict_remounted_animals,
    };
  }

  export function calc_months_last_year_array(last_year_start, last_year_end) {
    var months = dateRange(last_year_start, last_year_end);

    return months;
  }

  export function calc_balken_progress_table_active_boli_from_events_per_month(
    months,
    activated_all,
    marketing_start_date,
    marketing_end_date,
    laender_dict,
    pre_string = "activated_"
  ) {
    let ret_dict_activations = {};

    months.forEach((m) => {
      ret_dict_activations[m] = 0;
    });

    activated_all.forEach((element) => {
      if (!element["country_id"]) {
        return;
      }

      var country = element["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      months.forEach((m) => {
        if (pre_string + m in element) {
          ret_dict_activations[m] = ret_dict_activations[m] + element[pre_string + m];
        }
      });
    });

    return ret_dict_activations;
  }

  export function calc_balken_progress_table_active_boli_from_events_per_country_per_month(
    months,
    activated_all,
    marketing_start_date,
    marketing_end_date,
    laender_dict,
    pre_string = "activated_"
  ) {
    let ret_dict_activations = {};

    laender_dict.forEach((land_eintrag) => {
      ret_dict_activations[land_eintrag["long"]] = {};
      months.forEach((m) => {
        ret_dict_activations[land_eintrag["long"]][m] = 0;
      });
    });

    ret_dict_activations["ROW"] = {};
    months.forEach((m) => {
      ret_dict_activations["ROW"][m] = 0;
    });
    activated_all.forEach((element) => {
      if (!element["country_id"]) {
        return;
      }

      var country = element["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      months.forEach((m) => {
        if (pre_string + m in element) {
          if (country in ret_dict_activations) {
            ret_dict_activations[country][m] = ret_dict_activations[country][m] + element[pre_string + m];
          } else {
            ret_dict_activations["ROW"][m] = ret_dict_activations["ROW"][m] + element[pre_string + m];
          }
        }
      });
    });

    return ret_dict_activations;
  }

  export function dict_aufsummieren(dict) {
    let keys = Object.keys(dict);
    let ret_dict = {};
    let sum = 0;

    keys.forEach((k) => {
      sum = sum + dict[k];
      ret_dict[k] = sum;
    });
    return ret_dict;
  }

  export function calc_balken_progress_table_active_boli_from_events(months, activated_all, laender_dict, pre_string = "activated_") {
    let ret_dict_activations = {};

    months.forEach((m) => {
      ret_dict_activations[m] = 0;
    });

    activated_all.forEach((element) => {
      if (!element["country_id"]) {
        return;
      }

      var country = element["country_id"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      months.forEach((m) => {
        if (pre_string + m in element) {
          ret_dict_activations[m] = ret_dict_activations[m] + element[pre_string + m];
        }
      });
    });

    return ret_dict_activations;
  }

  export function multiply_dict(dict, mult) {
    let keys = Object.keys(dict);
    let ret_dict = {};
    let sum = 0;

    keys.forEach((k) => {
      ret_dict[k] = dict[k] * mult;
    });
    return ret_dict;
  }

  export function dividieren_dict_value_durch_dict(value, dict_2) {
    let keys = Object.keys(dict_2);
    let ret_dict = {};
    let sum = 0;

    keys.forEach((k) => {
      if (dict_2[k]) {
        ret_dict[k] = value / dict_2[k];
      } else {
        ret_dict[k] = undefined;
      }
    });
    return ret_dict;
  }

  export function replace_undefined_with_zero(dict) {
    let keys = Object.keys(dict);
    let ret_dict = {};
    let sum = 0;

    keys.forEach((k) => {
      if (typeof dict[k] === "undefined") {
        ret_dict[k] = 0;
      } else {
        ret_dict[k] = dict[k];
      }
    });
    return ret_dict;
  }

  export function replace_zero_with_undefined(dict) {
    let keys = Object.keys(dict);
    let ret_dict = {};
    let sum = 0;

    keys.forEach((k) => {
      if (dict[k] == 0) {
        ret_dict[k] = undefined;
      } else {
        ret_dict[k] = dict[k];
      }
    });
    return ret_dict;
  }

  export function dividieren_dict(dict, dict_2) {
    let keys = Object.keys(dict);
    let ret_dict = {};
    let sum = 0;

    keys.forEach((k) => {
      if (dict_2[k]) {
        if (!isNaN(dict[k] / dict_2[k])) {
          ret_dict[k] = dict[k] / dict_2[k];
        } else {
          ret_dict[k] = undefined;
        }
      } else {
        ret_dict[k] = undefined;
      }
    });
    return ret_dict;
  }

  export function calc_clv_values(
    all_months,
    months,
    charged_animals,
    hw,
    saas,
    infrastructure_revenue,
    clv_churn_rate,
    useful_life_infrastructure,
    useful_life_bolus
  ) {
    let ret_dict = {};
    let pre_month = 0;
    let pre_pre_month = 0;

    all_months.forEach((m) => {
      if (months.includes(m)) {
        var invoiced_boli = charged_animals[m] > 0 ? charged_animals[m] : charged_animals[pre_month];
        var invoiced_boli_prevmonth = charged_animals[m] > 0 ? charged_animals[pre_month] : charged_animals[pre_pre_month];

        var clv_boli = invoiced_boli + ((invoiced_boli - invoiced_boli_prevmonth) / 3) * 2;
        //var clv_value = clv_boli * (saas[m] + hw[m] + infrastructure_revenue[m]/12) / (clv_churn_rate[m]/10);
        var clv_value =
          (clv_boli * (saas[m] + hw[m] / useful_life_bolus + infrastructure_revenue[m] / useful_life_infrastructure)) /
          (clv_churn_rate[m] / (12 * 100));

        // var clv_value = clv_boli * (saas[m] + hw[m]/useful_life_bolus + infrastructure_revenue[m]/useful_life_infrastructure) / (0.0042);

        //Useful_life_Infrastructure_HW

        ret_dict[m] = clv_value;
      }
      pre_pre_month = pre_month;
      pre_month = m;
    });

    return ret_dict;
  }

  export function replace_zero_with_previous_month(months, charged_animals) {
    let ret_dict = {};

    let pre_month = 0;

    months.forEach((m) => {
      if (charged_animals[m] == 0) {
        if (pre_month) {
          ret_dict[m] = charged_animals[pre_month];
        } else {
          ret_dict[m] = 0;
        }
      } else {
        ret_dict[m] = charged_animals[m];
      }
      pre_month = m;
    });

    return ret_dict;
  }

  export function calc_balken_progress_table_active_boli(months, messenger_res, date_start, date_end, laender_dict, exclude_sales = true) {
    let ret_dict_new_animals = {};

    months.forEach((m) => {
      ret_dict_new_animals[m] = 0;
    });

    let ret_dict_active_animals = {};

    months.forEach((m) => {
      ret_dict_active_animals[m] = 0;
    });

    let ret_dict_deactivated_animals = {};

    months.forEach((m) => {
      ret_dict_deactivated_animals[m] = 0;
    });

    let ret_dict_remounted_animals = {};

    months.forEach((m) => {
      ret_dict_remounted_animals[m] = 0;
    });

    let ret_dict_charged_animals = {};
    months.forEach((m) => {
      ret_dict_charged_animals[m] = 0;
    });

    messenger_res.forEach((messenger) => {
      var obj = messenger[1];
      var date = obj["date"];
      var new_animals = obj["new_animals"];
      var active_animals = obj["active_animals"];
      var deactivated_animals = obj["inactive_animals"];
      var remounted_animals = obj["remounted_animals"];
      var charged_animals = obj["qty"];

      if (!obj["x_studio_country"]) {
        return;
      }
      var country = obj["x_studio_country"][1];
      if (!is_country_checked(laender_dict, country)) {
        return;
      }

      if (date.substring(0, 7) in ret_dict_new_animals) {
        ret_dict_new_animals[date.substring(0, 7)] += new_animals;
      }
      if (date.substring(0, 7) in ret_dict_active_animals) {
        ret_dict_active_animals[date.substring(0, 7)] += active_animals;
      }
      if (date.substring(0, 7) in ret_dict_active_animals) {
        ret_dict_deactivated_animals[date.substring(0, 7)] += deactivated_animals;
      }
      if (date.substring(0, 7) in ret_dict_remounted_animals) {
        ret_dict_remounted_animals[date.substring(0, 7)] += remounted_animals;
      }
      if (date.substring(0, 7) in ret_dict_charged_animals) {
        ret_dict_charged_animals[date.substring(0, 7)] += charged_animals;
      }
    });

    return {
      new_animals: ret_dict_new_animals,
      active_animals: ret_dict_active_animals,
      deactivated_animals: ret_dict_deactivated_animals,
      remounted_animals: ret_dict_remounted_animals,
      charged_animals: ret_dict_charged_animals,
    };
  }

  export function add_thereof_new_boli(animals_table_values, laender_dict, months) {
    animals_table_values["thereof_new_boli"] = {};
    laender_dict.forEach((c) => {
      animals_table_values["thereof_new_boli"][c["long"]] = {};
      months.forEach((m) => {
        animals_table_values["thereof_new_boli"][c["long"]][m] =
          animals_table_values["new_animals"][c["long"]][m] - animals_table_values["remounted_animals"][c["long"]][m];
      });
    });
  }

  export function calc_fields_from_animals_table_per_country_per_month(
    messenger_res,
    months,
    countires,
    marketing_start_date_t,
    marketing_end_date_t,
    fields,
    calc_basis = false
  ) {
    let ret_dict = {};

    var marketing_start_date = new Date(marketing_start_date_t);
    var marketing_end_date = new Date(marketing_end_date_t);

    if (calc_basis) {
      marketing_start_date.setFullYear(marketing_start_date.getFullYear() - 1);
      marketing_end_date.setFullYear(marketing_end_date.getFullYear() - 1);
    }

    fields.forEach((f) => {
      ret_dict[f] = {};
      countires.forEach((c) => {
        ret_dict[f][c["long"]] = {};
        months.forEach((m) => {
          if (calc_basis) {
            ret_dict[f][c["long"]][substract_year_from_month_string(m)] = 0;
          } else {
            ret_dict[f][c["long"]][m] = 0;
          }
        });
      });
    });

    messenger_res.forEach((val) => {
      var element = 1 in val ? val[1] : val;
      var date = element["date"];
      var country = element["x_studio_country"];
      var active_animals = element["active_animals"];

      if (!country || !date) {
        return;
      }

      if (!is_country_checked(countires, country[1])) {
        return;
      }

      if (country[1] in ret_dict) {
        fields.forEach((f) => {
          if (date.substring(0, 7) in ret_dict[f][country[1]]) {
            ret_dict[f][country[1]][date.substring(0, 7)] += element[f];
          }
        });
      } else {
        fields.forEach((f) => {
          if (date.substring(0, 7) in ret_dict[f]["ROW"]) {
            ret_dict[f]["ROW"][date.substring(0, 7)] += element[f];
          }
        });
      }
    });

    if (calc_basis) {
      countires.forEach((c) => {
        fields.forEach((f) => {
          ret_dict[f][c["long"]] = ret_dict[f][c["long"]][substract_year_from_month_string(months[months.length - 1])];
        });
      });
    }

    return ret_dict;
  }

  export function aufsummieren(dict_activations, active_boli_basis_per_country, months, laender_dict) {
    laender_dict.forEach((land_eintrag) => {
      var sum = dict_to_sum(active_boli_basis_per_country[land_eintrag["long"]]);
      months.forEach((m) => {
        sum = sum + dict_activations[land_eintrag["long"]][m];
        dict_activations[land_eintrag["long"]][m] = sum;
      });
    });
  }

  export function calc_active_boli_per_country_per_month(messenger_res, months, countires, marketing_start_date, marketing_end_date) {
    let ret_dict = {};

    countires.forEach((c) => {
      ret_dict[c["long"]] = {};

      months.forEach((m) => {
        ret_dict[c["long"]][m] = 0;
      });
    });

    messenger_res.forEach((val) => {
      var element = 1 in val ? val[1] : val;
      var date = element["date"];
      var country = element["x_studio_country"];
      var active_animals = element["active_animals"];

      if (!country || !date) {
        return;
      }

      if (!is_country_checked(countires, country[1])) {
        return;
      }

      if (country[1] in ret_dict) {
        if (date.substring(0, 7) in ret_dict[country[1]]) {
          ret_dict[country[1]][date.substring(0, 7)] += active_animals;
        }
      } else {
        if (date.substring(0, 7) in ret_dict["ROW"]) {
          ret_dict["ROW"][date.substring(0, 7)] += active_animals;
        }
      }
    });

    return ret_dict;
  }

  function format(inputDate) {
    let date, month, year;

    date = inputDate.getDate();
    month = inputDate.getMonth() + 1;
    year = inputDate.getFullYear();

    date = date.toString().padStart(2, "0");

    month = month.toString().padStart(2, "0");

    return `${year}-${month}-${date}`;
  }

  export function dateRange(startDate, endDate) {
    var startDatestr = format(startDate);
    var endDatestr = format(endDate);

    var start = startDatestr.split("-");
    var end = endDatestr.split("-");
    var startYear = parseInt(start[0]);
    var endYear = parseInt(end[0]);
    var dates = [];

    for (var i = startYear; i <= endYear; i++) {
      var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
      var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
      for (var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
        var month = j + 1;
        var displayMonth = month < 10 ? "0" + month : month;
        dates.push([i, displayMonth].join("-"));
      }
    }
    return dates;
  }

  export function subtractYears(numOfYears, date = new Date()) {
    const dateCopy = new Date(date.getTime());

    dateCopy.setFullYear(dateCopy.getFullYear() - numOfYears);

    return dateCopy;
  }

  export function dict_to_average(dict) {
    return dict_to_sum(dict) / Object.keys(dict).length;
  }

  export function dict_to_median(dict) {
    var list_of_values = Object.values(dict);

    list_of_values.sort(function (a, b) {
      return a - b;
    });

    var median = list_of_values[Math.floor(list_of_values.length / 2)];
    return median;
  }

  export function dict_to_sum_2d_each_last_month(dict) {
    var sum = 0;
    Object.keys(dict).forEach(function (key) {
      sum += get_last_month_value(dict[key]);
    });

    return sum;
  }

  export function get_last_month_value(dict) {
    return dict[Object.keys(dict)[Object.keys(dict).length - 1]];
  }

  export function dict_to_sum_2d(dict) {
    var sum = 0;
    Object.keys(dict).forEach(function (key) {
      sum += dict_to_sum(dict[key]);
    });

    return sum;
  }

  export function dict_to_sum(dict) {
    var list_of_values = Object.values(dict);

    return list_of_values.reduce((partialSum, a) => partialSum + a, 0);
  }

  export function max_of_dict(dict) {
    var list_of_values = Object.values(dict);

    return Math.max(...list_of_values);
  }

  export function tausender_trenner(number) {
    if (typeof number == "string") {
      return number;
    }

    // Info: Die '' sind zwei Hochkommas
    number = "" + number;
    if (number.length > 3) {
      var mod = number.length % 3;
      var output = mod > 0 ? number.substring(0, mod) : "";
      var i = 0;
      for (i = 0; i < Math.floor(number.length / 3); i++) {
        if (mod == 0 && i == 0) output += number.substring(mod + 3 * i, mod + 3 * i + 3);
        // hier wird das Trennzeichen festgelegt mit '.'
        else output += "." + number.substring(mod + 3 * i, mod + 3 * i + 3);
      }
      return output;
    } else return number;
  }
</script>
